import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaUserLock} from 'react-icons/fa';
import logo from "../assets/images/logo.jpg";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Top Info Bar */}
      <div className="top-info-bar bg-success text-white py-2 d-none d-lg-block">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7">
              <div className="d-flex gap-4 flex-wrap">
                <span className="d-flex align-items-center gap-2">
                  <FaPhone className="text-warning" />
                  <small>+91-9031654981 | 9031654984</small>
                </span>
                <span className="d-flex align-items-center gap-2">
                  <FaEnvelope className="text-warning" />
                  <small>askus@rengie.in</small>
                </span>
                <span className="d-flex align-items-center gap-2">
                  <FaMapMarkerAlt className="text-warning" />
                  <small>Patna | Ranchi</small>
                </span>
              </div>
            </div>
            <div className="col-lg-5 text-end d-flex justify-content-end align-items-center">
              <small className="badge bg-warning text-dark">
                ⚡ DPIIT Recognized Startup
              </small>
              <small className="badge bg-light text-dark ms-2">
                🌱 Green Technology Sector
              </small>
              <Link 
                to="/admin/login" 
                className="text-white text-decoration-none d-flex align-items-center gap-1 ms-3"
                style={{ fontSize: '0.85rem', opacity: 0.9, borderLeft: '1px solid rgba(255,255,255,0.3)', paddingLeft: '10px' }}
                title="Admin Login"
              >
                <FaUserLock /> <small>Login</small>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <nav 
        className={`navbar navbar-expand-lg sticky-top ${
          scrolled ? 'navbar-scrolled shadow-lg' : ''
        }`}
        style={{
          backgroundColor: scrolled ? '#ffffff' : 'rgba(255, 255, 255, 0.98)',
          transition: 'all 0.3s ease',
          borderBottom: scrolled ? '3px solid #00D084' : '1px solid rgba(0,0,0,0.1)'
        }}
      >
        <div className="container">
          {/* Logo */}
          <a className="navbar-brand d-flex align-items-center" href="#home">
            <img 
              src={logo} 
              alt="RENGIE Logo" 
              height="50"
              className="me-2"
            />
          </a>

          {/* Mobile Toggle Button */}
          <button
            className="navbar-toggler border-0"
            type="button"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-expanded={mobileMenuOpen}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Navbar Links */}
          <div 
            className={`collapse navbar-collapse ${mobileMenuOpen ? 'show' : ''}`}
            id="navbarNav"
          >
            <ul className="navbar-nav ms-auto align-items-lg-center gap-lg-1">
              {/* Home */}
              <li className="nav-item">
                <a 
                  className="nav-link fw-semibold text-dark" 
                  href="#home"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Home
                </a>
              </li>

              {/* About Us */}
              <li className="nav-item">
                <a 
                  className="nav-link fw-semibold text-dark" 
                  href="#about"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  About Us
                </a>
              </li>

              {/* Services Dropdown */}
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle fw-semibold text-dark"
                  href="#services"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Services
                </a>
                <ul className="dropdown-menu shadow-lg border-0">
                  <li>
                    <a 
                      className="dropdown-item py-2" 
                      href="#services"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      <i className="bi bi-house-door text-success me-2"></i>
                      Residential Rooftop Solar
                    </a>
                  </li>
                  <li>
                    <a 
                      className="dropdown-item py-2" 
                      href="#services"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      <i className="bi bi-building text-success me-2"></i>
                      Commercial & Institutional Solar
                    </a>
                  </li>
                  <li>
                    <a 
                      className="dropdown-item py-2" 
                      href="#services"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      <i className="bi bi-buildings text-success me-2"></i>
                      Society & Group Housing Solar
                    </a>
                  </li>
                  <li>
                    <a 
                      className="dropdown-item py-2" 
                      href="#services"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      <i className="bi bi-droplet text-success me-2"></i>
                      Solar Water Heater
                    </a>
                  </li>
                  <li>
                    <a 
                      className="dropdown-item py-2" 
                      href="#services"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      <i className="bi bi-lightning-charge text-success me-2"></i>
                      DRE Based Micro-Enterprise
                    </a>
                  </li>
                  <li><hr className="dropdown-divider" /></li>
                  <li>
                    <a 
                      className="dropdown-item py-2 text-primary fw-semibold" 
                      href="#why-us"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      <i className="bi bi-award me-2"></i>
                      Why Choose RENGIE?
                    </a>
                  </li>
                </ul>
              </li>

              {/* PM Suryaghar Yojana */}
              <li className="nav-item">
                <a 
                  className="nav-link fw-semibold text-primary" 
                  href="#pm-suryaghar"
                  style={{ position: 'relative' }}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  PM Suryaghar Yojana
                  <span 
                    className="badge bg-danger position-absolute top-0 start-100 translate-middle"
                    style={{ fontSize: '0.6rem' }}
                  >
                    Subsidy
                  </span>
                </a>
              </li>

              {/* Gallery - NEW! */}
              <li className="nav-item">
                <a 
                  className="nav-link fw-semibold text-dark" 
                  href="#gallery"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <i className="bi bi-images me-1"></i>
                  Gallery
                </a>
              </li>

              {/* Contact */}
              <li className="nav-item">
                <a 
                  className="nav-link fw-semibold text-dark" 
                  href="#contact"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Contact Us
                </a>
              </li>

              {/* CTA Buttons */}
              <li className="nav-item ms-lg-2">
                <a 
                  href="#contact" 
                  className="btn btn-outline-success btn-sm rounded-pill px-3 mb-2 mb-lg-0"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <i className="bi bi-telephone-fill me-1"></i>
                  Call Engineer
                </a>
              </li>
              <li className="nav-item ms-lg-2">
                <a 
                  href="#contact" 
                  className="btn btn-success btn-sm rounded-pill px-3 shadow-sm"
                  style={{ 
                    background: 'linear-gradient(135deg, #00D084 0%, #00B572 100%)',
                    border: 'none'
                  }}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <i className="bi bi-clipboard-check me-1"></i>
                  Free Site Survey
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Trust Badge Strip (Below Navbar) */}
      <div className="trust-badge-strip bg-light py-2 border-bottom">
        <div className="container">
          <div className="row text-center">
            <div className="col-6 col-md-3 mb-2 mb-md-0">
              <small className="text-muted">
                <i className="bi bi-patch-check-fill text-success me-1"></i>
                <strong>Empanelled with SBPDCL</strong>
              </small>
            </div>
            <div className="col-6 col-md-3 mb-2 mb-md-0">
              <small className="text-muted">
                <i className="bi bi-patch-check-fill text-success me-1"></i>
                <strong>Empanelled with NBPDCL</strong>
              </small>
            </div>
            <div className="col-6 col-md-3">
              <small className="text-muted">
                <i className="bi bi-patch-check-fill text-success me-1"></i>
                <strong>Empanelled with JBVNL</strong>
              </small>
            </div>
            <div className="col-6 col-md-3">
              <small className="text-muted">
                <i className="bi bi-star-fill text-warning me-1"></i>
                <strong>NIT & DTU Alumni Team</strong>
              </small>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
